// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"70032524","453":"f5b45f51"}[chunkId] + ".chunk.js";
};